// extracted by mini-css-extract-plugin
module.exports = {"topper":"tool_topper_topper__2JQWE","textBlock":"tool_topper_textBlock__FHwmt"};